import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

const PRIVACY_URL =
  (window.wp_vars && window.wp_vars.privacy_url) || "/polityka-prywatnosci/";

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

function syncGoogleConsent() {
  const granted = CookieConsent.acceptedCategory("analytics");
  gtag("consent", "update", {
    analytics_storage: granted ? "granted" : "denied",
  });
  window.dataLayer.push({ event: "cc_consent_update" });
}

export function initCookieConsent() {
  CookieConsent.run({
    onConsent: syncGoogleConsent,
    onChange: syncGoogleConsent,
    guiOptions: {
      consentModal: {
        layout: "box",
        position: "bottom right",
      },
      preferencesModal: {
        layout: "box",
      },
    },
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {
        autoClear: {
          cookies: [{ name: /^_ga/ }, { name: "_gid" }],
        },
      },
    },
    language: {
      default: "pl",
      translations: {
        pl: {
          consentModal: {
            title: "Dbamy o Twoją prywatność",
            description:
              "Używamy niezbędnych plików cookie, aby strona działała poprawnie. Za Twoją zgodą korzystamy też z Google Analytics, by lepiej rozumieć, jak używasz serwisu.",
            acceptAllBtn: "Akceptuję wszystkie",
            acceptNecessaryBtn: "Tylko niezbędne",
            showPreferencesBtn: "Ustawienia",
            footer:
              '<a href="' +
              PRIVACY_URL +
              '">Polityka prywatności</a>',
          },
          preferencesModal: {
            title: "Ustawienia plików cookie",
            acceptAllBtn: "Akceptuję wszystkie",
            acceptNecessaryBtn: "Tylko niezbędne",
            savePreferencesBtn: "Zapisz ustawienia",
            closeIconLabel: "Zamknij",
            sections: [
              {
                title: "Pliki niezbędne",
                description:
                  "Te pliki cookie są konieczne do prawidłowego działania strony i nie można ich wyłączyć.",
                linkedCategory: "necessary",
              },
              {
                title: "Analityka (Google Analytics)",
                description:
                  "Pomagają nam zrozumieć, jak odwiedzający korzystają ze strony. Wszystkie dane są zbierane anonimowo.",
                linkedCategory: "analytics",
              },
              {
                title: "Więcej informacji",
                description:
                  'Szczegóły znajdziesz w naszej <a href="' +
                  PRIVACY_URL +
                  '">polityce prywatności</a>.',
              },
            ],
          },
        },
      },
    },
  });
}
